import { useState, useEffect } from 'react';

const QUERY = '(prefers-reduced-motion: no-preference)';

export function usePrefersReducedMotion(): boolean {
    const ssr = typeof window === 'undefined';
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(ssr);

    useEffect(() => {
        const mediaQueryList: MediaQueryList = window.matchMedia(QUERY);

        setPrefersReducedMotion(!mediaQueryList.matches);

        // addEventListener isn't supported on older implementations of
        // matchMedia
        if (!mediaQueryList.addEventListener) {
            return;
        }

        const listener: (event: MediaQueryListEvent) => void = (
            event: MediaQueryListEvent
        ) => {
            setPrefersReducedMotion(!event.matches);
        };

        mediaQueryList.addEventListener('change', listener);

        return () => {
            mediaQueryList.removeEventListener('change', listener);
        };
    }, []);

    return prefersReducedMotion;
}
